/**
 * Homepage content — value props, occasions, social (product images wired at runtime).
 */

export const homeValueProps = [
  {
    key: "magnetic",
    title: "Magnetic closure",
    text: "Premium unboxing every time — boxes that snap shut and feel worth keeping.",
  },
  {
    key: "custom",
    title: "Personalised touches",
    text: "Custom box messages, curated keepsakes, and gift-ready presentation.",
  },
  {
    key: "shipping",
    title: "Tracked delivery",
    text: "Shiprocket rates at checkout with UPI or cash on delivery across India.",
  },
  {
    key: "corporate",
    title: "Corporate gifting",
    text: "Bulk orders for teams, clients, and events — tailored to your brand.",
  },
];

export const featuredCategories = [
  {
    slug: "Birthday",
    title: "Birthday",
    subtitle: "Joy wrapped in ribbons",
    gradient: "linear-gradient(135deg, #fff6e8 0%, #f4d9a8 50%, #e8c48a 100%)",
  },
  {
    slug: "Wedding",
    title: "Wedding",
    subtitle: "Elegant keepsakes",
    gradient: "linear-gradient(135deg, #fffef8 0%, #f5ecd8 50%, #e8dcc4 100%)",
  },
  {
    slug: "Corporate",
    title: "Corporate",
    subtitle: "Impress every client",
    gradient: "linear-gradient(135deg, #eef4ff 0%, #c5d4f0 50%, #8fa8d8 100%)",
  },
  {
    slug: "Festive",
    title: "Festive",
    subtitle: "Seasonal hampers",
    gradient: "linear-gradient(135deg, #1a2744 0%, #2d3f5c 40%, #c5a06d 100%)",
  },
  {
    slug: "Thank",
    title: "Thank you",
    subtitle: "Gratitude, beautifully boxed",
    gradient: "linear-gradient(135deg, #fdf2f4 0%, #f5c6d6 45%, #e8a4bc 100%)",
  },
  {
    slug: "Baby",
    title: "New baby",
    subtitle: "Soft celebration-ready gifts",
    gradient: "linear-gradient(135deg, #fffafd 0%, #fce4ec 55%, #f8bbd9 100%)",
  },
];

/** @deprecated Use homeValueProps on the new homepage */
export const whyLuxury = homeValueProps.map((row) => ({
  ...row,
  key: row.key === "custom" ? "notes" : row.key === "magnetic" ? "packaging" : row.key,
}));

export const trendingProducts = [];

export const testimonials = [
  {
    id: 1,
    quote:
      "The box felt boutique-quality from the first touch. The magnetic lid and finishing made it a gift in itself.",
    name: "Primita Lobo",
    role: "Thane",
  },
  {
    id: 2,
    quote:
      "Ordering was smooth, delivery was tracked, and the hamper looked exactly like the photos. Will order again.",
    name: "Justine Andru",
    role: "Bangalore",
  },
  {
    id: 3,
    quote:
      "We used Rencin for client gifting — professional packaging and a warm unboxing moment every time.",
    name: "Aisha Mehta",
    role: "Mumbai",
  },
];

export const socialGridImages = [];
